export const TASK_ASSIGNEES = [
  { value: "Steven", label: "Steven" },
  { value: "Richard", label: "Richard" },
  { value: "Both", label: "Both" },
];

export const TASK_PRIORITIES = [
  { value: "Low", label: "Low" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
  { value: "Critical", label: "Critical" },
];

export const TASK_STATUSES = [
  { value: "To do", label: "To do" },
  { value: "In progress", label: "In progress" },
  { value: "Complete", label: "Complete" },
  { value: "Cancelled", label: "Cancelled" },
];

export const TASK_WORKSTREAMS = [
  { value: "Product and Content", label: "Product and Content" },
  { value: "Launch", label: "Launch" },
  { value: "Marketing", label: "Marketing" },
  { value: "Investors", label: "Investors" },
  { value: "Finance", label: "Finance" },
  { value: "Operations", label: "Operations" },
  { value: "Future Innovations", label: "Future Innovations" },
  { value: "Other", label: "Other" },
];

// founder chip colours (royal blue / teal / warm orange)
export const founderChip = (who) =>
  ({
    Steven: "bg-[#1D4ED8]/12 text-[#1D4ED8] ring-1 ring-[#1D4ED8]/25",
    Richard: "bg-[#0EA5A4]/12 text-[#0C8E8D] ring-1 ring-[#0EA5A4]/25",
    Both: "bg-[#E0A82E]/15 text-[#B8791A] ring-1 ring-[#E0A82E]/30",
  }[who] || "bg-[#EEF2FB] text-[#5A6B8C]");

export const priorityBadge = (p) =>
  ({ Low: "neutral", Medium: "info", High: "warning", Critical: "error" }[p] || "neutral");

export const statusBadge = (s) =>
  ({
    "To do": "neutral",
    "In progress": "info",
    Complete: "success",
    Cancelled: "neutral",
  }[s] || "neutral");

// status column accent for kanban / board
export const statusAccent = (s) =>
  ({
    "To do": "#5A6B8C",
    "In progress": "#06B6D4",
    Complete: "#16A34A",
    Cancelled: "#9DAAC6",
  }[s] || "#5A6B8C");

export const RELATION_FIELDS = [
  { key: "related_milestone_id", label: "Launch milestone", resource: "launch-milestones", nameKey: "title" },
  { key: "related_module_id", label: "Module", resource: "modules", nameKey: "name" },
  { key: "related_chapter_id", label: "Chapter", resource: "chapters", nameKey: "name" },
  { key: "related_campaign_id", label: "Campaign", resource: "marketing-campaigns", nameKey: "name" },
  { key: "related_investor_id", label: "Investor", resource: "investors", nameKey: "name" },
  { key: "related_innovation_id", label: "Future Innovation", resource: "innovations", nameKey: "title" },
];

// Europe/London calendar date (YYYY-MM-DD). Used for scheduling defaults and the
// "Today" board filter so a UTC offset can never shift a task to the wrong day.
export const ukToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/London" }).format(new Date());
export const ukAddDays = (n) => {
  const base = new Date(`${ukToday()}T00:00:00`);
  base.setDate(base.getDate() + n);
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/London" }).format(base);
};

const today = () => ukToday();

export const isOverdue = (t) => {
  if (!t || ["Complete", "Cancelled"].includes(t.status)) return false;
  if (!t.due_date) return false;
  const d = today();
  if (t.due_date < d) return true;
  if (t.due_date === d && t.due_time) {
    return `${t.due_date}T${t.due_time}:00` < new Date().toISOString().slice(0, 19);
  }
  return false;
};

export const fmtMinutes = (m) => {
  if (m == null || m === "") return null;
  const n = Number(m);
  if (!n) return null;
  const h = Math.floor(n / 60);
  const mm = n % 60;
  return h ? `${h}h${mm ? ` ${mm}m` : ""}` : `${mm}m`;
};

// unique founders flagged (@mentioned) across a task's notes
export const taskMentions = (t) => {
  const set = new Set();
  (t?.comments || []).forEach((c) => (c.mentions || []).forEach((m) => set.add(m)));
  return [...set];
};
